module.exports = __webpack_public_path__ + "static/vf_wpullover_core.c44fe44b.svg";